<template>
    <v-container>
        <v-row justify="center" class="mb-10">
            <v-col cols="12" sm="10" md="7" lg="5">
                <TopBar backPage="booking" hideHeader/>
                <v-divider class=""></v-divider>
                <div v-if="$store.state.info.active" class="mt-3" >
                    <v-card>
                        <v-card-text>
                            <v-select
                                :items="$store.state.info.payment_methods"
                                itemValue="id"
                                v-model="payment_method"
                                density="compact"
                                variant="outlined"
                                label="شیوه پرداخت"
                                />
                            <v-select
                                :items="$store.state.info.order_types"
                                itemValue="id"
                                v-model="order_type"
                                density="compact"
                                variant="outlined"
                                label="نحوه سفارش"
                                />
                            <template v-if="order_type == 1">
                                <v-text-field
                                    density="compact"
                                    dir="ltr"
                                    class="text-center"
                                    v-model="table_number"
                                    :readonly="!$store.state.table_number_editable"
                                    variant="outlined"
                                    label="شماره میز"
                                    />
                            </template>
                            <template v-if="order_type == 3">
                                <!-- <v-textarea
                                    density="compact"
                                    v-model="delivery_address"
                                    variant="outlined"
                                    rows="2"
                                    label="آدرس دقیق برای ارسال سفارش"
                                    /> -->
                                <div class="d-flex justify-space-between align-center">
                                    <strong>آدرس:</strong>
                                    <v-btn color="info" size="small" @click="addAddressDialogStatus = !addAddressDialogStatus;delivery_address=''">
                                         <v-icon>mdi-plus</v-icon>
                                        افزودن آدرس
                                    </v-btn>
                                </div>
                                <v-radio-group v-model="delivery_address">
                                    <v-radio
                                        v-for="(a,index) in $store.state.info.addresses"
                                        :key="index+`address`"
                                        density="compact"
                                        variant="outlined"
                                        :label="a"
                                        :value="a"
                                    ></v-radio>
                                </v-radio-group>
                            </template>
                            <v-textarea
                                density="compact"
                                variant="outlined"
                                v-model="order_description"
                                rows="2"
                                label="توضیحات"
                                />
                           <span class="text-red" v-html="$store.state.info.payment_methods.find(e=>e.id == payment_method).description.replaceAll('\n','<br/>')">
                           </span>
                        </v-card-text>
                        <v-card-actions>
                            <strong>
                                {{ $t('final_price') }}
                            </strong>
                            <v-spacer></v-spacer>
                            <strong>
                                {{ new Intl.NumberFormat('fa-IR').format(
                                    $store.getters.cartTotalPrice + ($store.getters.cartTotalPrice*$store.state.info.tax) + ((order_type == 3 && $store.state.info.shipping_price > 0)?$store.state.info.shipping_price:0)
                                    ) }}
                            </strong>
                            {{ $t('rial') }}
                        </v-card-actions>
                        <div class="d-flex flex-column px-3 text-grey text-body-2" v-if="$store.state.info.tax > 0">
                            <div class="d-flex justify-space-between">
                                <div>
                                    {{ $t('sum_cart_price') }}:
                                </div>
                                <div>
                                    <strong>{{ new Intl.NumberFormat('fa-IR').format($store.getters.cartTotalPrice) }}</strong>
                                    {{ $t('rial') }}
                                </div>
                            </div>
                            <div class="d-flex justify-space-between">
                                <div>
                                    {{ $t('tax') }}:
                                </div>
                                <div>
                                    <strong>{{ new Intl.NumberFormat('fa-IR').format($store.getters.cartTotalPrice*$store.state.info.tax) }}</strong>
                                    {{ $t('rial') }}
                                </div>
                            </div>
                            <div class="d-flex justify-space-between" v-if="order_type == 3 && $store.state.info.shipping_price > 0">
                                <div>
                                    {{ $t('shipping_price') }}:
                                </div>
                                <div>
                                    <strong>{{ new Intl.NumberFormat('fa-IR').format($store.state.info.shipping_price) }}</strong>
                                    {{ $t('rial') }}
                                </div>
                            </div>
                        </div>
                        <v-divider
                            class="my-2"
                        ></v-divider>

                        
                        <v-card-text>
                            <p class="text-center" v-if="$store.state.info.min_bascket > 0 && $store.getters.cartTotalPrice < $store.state.info.min_bascket">
                                برای ثبت سفارش، مبلغ سفارش باید بیشتر از {{ new Intl.NumberFormat('fa-IR').format($store.state.info.min_bascket) }} ریال باشد
                            </p>
                             <v-btn
                                :disabled="$store.state.info.min_bascket > 0 && $store.getters.cartTotalPrice < $store.state.info.min_bascket"
                                block
                                color="red"
                                variant="flat"
                                append-icon="mdi-check"
                                :loading="$store.state.bookingLoading"
                                @click="$store.dispatch('SubmitOrder',{
                                    payment_method:payment_method,
                                    order_type:order_type,
                                    table_number:table_number,
                                    delivery_address:delivery_address,
                                    order_description:order_description,
                                })"
                                >
                                {{ $t('submit_order') }}
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </div>
                <v-alert v-else color="warning" class="mt-3" density="compact" icon="mdi-bell" :value="true">
                    شیفت کاری در حال حاضر فعال نمی‌باشد!
                </v-alert>
                <v-card class="mt-3 pt-3">
                    <v-card-text class="pa-1">
                        <div class="cart-detail">
                            <h4 class="mr-3">جزئیات سفارش:</h4>
                            <v-card class="border-b-sm border-solid my-1 py-3 px-2" color="white" variant="flat"  v-for="(cartItem,index) in $store.state.cart" :key="`cartItem`+index">
                                <div class="d-flex flex-column justify-space-between">
                                    <div class="d-flex justify-space-between">
                                        <strong style="flex-grow: 2;">
                                            {{ cartItem.title }}
                                            <span v-if="!!cartItem.variable && cartItem.variable.name"
                                                class="text-caption text-grey-darken-3">
                                                ({{ cartItem.variable.name }})
                                            </span>
                                        </strong>
                                        <strong style="flex-grow: 0;" class="pl-5">
                                            {{cartItem.total}} عدد
                                        </strong>
                                        <strong style="flex-grow: 0;">{{ new Intl.NumberFormat('fa-IR').format($store.getters.calcCartItemPrice(index)) }}</strong>
                                    </div>
                                    <div v-if="!!cartItem.addons && cartItem.addons.length > 0" class="d-flex flex-column mt-1">
                                        <div v-for="(addon,index) in cartItem.addons" :key="`addon`+index" class="text-grey my-1">
                                            <v-icon>mdi-plus</v-icon>
                                            {{ addon.title }}
                                            ({{ addon.total }})
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog
        v-if="addAddressDialogStatus"
            v-model="addAddressDialogStatus"
            scrollable 
            persistent :overlay="false"
            max-width="500px"
            transition="dialog-transition"
        >
            <v-card>
                <v-card-actions>
                    <h3>افزودن آدرس</h3>
                    <v-spacer></v-spacer>
                    <v-btn color="error" size="small" @click="addAddressDialogStatus=false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-actions>
                    <v-divider
                    ></v-divider>
                <v-card-text>
                    <v-textarea
                        density="compact"
                        v-model="delivery_address"
                        variant="outlined"
                        rows="3"
                        label="آدرس دقیق برای ارسال سفارش"
                        hide-details
                        />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn variant="outlined" color="primary" @click="SubmitAddress" :loading="loading">تایید</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import TopBar from '@/components/top_bar.vue';

    export default {
        name: "OrderPage",
        components: {
            TopBar,
        },
        data() {
            return {
                payment_method:0,
                order_type:0,
                table_number:"",
                delivery_address:"",
                order_description:"",

                addAddressDialogStatus:false,
                loading:false,
            };
        },
        methods:{
            async SubmitAddress() {
                this.loading = true;
                try {
                    const response = await this.$api.put('/booking/user/profile/address', {
                        delivery_address: this.delivery_address,
                    });
                    if(response.data.success){
                        this.addAddressDialogStatus = false;
                        this.$store.commit('setAddresses', response.data.data);
                    }
                } catch (error) {
                    console.error(error);
                }
                this.loading = false;
            }
        },
        created(){
            if(!!this.$store.state.info.payment_methods && this.$store.state.info.payment_methods.length > 0){
                this.payment_method = this.$store.state.info.payment_methods[0].id
            }
            if(!!this.$store.state.info.order_types && this.$store.state.info.order_types.length > 0){
                this.order_type = this.$store.state.info.order_types[0].id
            }
            if(this.$store.state.table_number != ""){
                this.table_number = this.$store.state.table_number;
            }
        }
    };
</script>

<style>
    .text-center {
        text-align: center;
    }
    .business-card-list-item-text a, a:visited, a:hover, a:active, a:focus {
        color: black !important;
        text-decoration: none !important;
    }


    .service-img {
        border-radius: 10px;
        transition: all .2s;
        width: 120px;
        height: 120px;
        object-fit: cover;
    }
    .cat-image {
        border-radius: 10px;
        transition: all .2s;
        width: 50px;
        height: 50px;
        object-fit: cover;
    }
    .v-slide-group__content{
        justify-content: center;
    }

.text-center input {
  text-align: center;
}
</style>